// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2w7m_","left":"styles_left__1ztIz","desktopActions":"styles_desktopActions__3Hh1A","title":"styles_title__2Mwal"};